<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="40%"
    class="agreeDialog"
  >
    <el-form class="common_form" label-position="left" ref="agreeDialogForm" :rules="rules" label-width="180px" :model="formData">
      <el-row>
        <el-col :span="24">
          <el-form-item :label="$t('approvalCenter.AppCom')">
            <el-input type="textarea" v-model="formData.reason" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{$t('btn.Cancel')}}</el-button>
      <el-button type="primary" @click="subBtn">{{$t('btn.OK')}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      rules: {
        directors: [
          { required: true, message: this.$t('approvalCenter.Psaem'), trigger: 'blur' }
        ],
        reason: [
          { required: true, message: this.$t('approvalCenter.Peac'), trigger: 'blur' }
        ]
      },
      dialogVisible: false,
      formData: {
        reason: ''
      },
      dialogTitle: '同意'
    };
  },
  methods: {
    init (parameter) {
      const { type, agreeDialogVisible } = parameter;
      this.dialogTitle = type;
      this.dialogVisible = agreeDialogVisible;
      this.formData.reason = type;
    },
    subBtn () {
      this.$refs['agreeDialogForm'].validate((valid) => {
        if (valid) {
          this.$emit('agreeSubHandle', {
            reason: this.formData.reason,
            type: this.dialogTitle
          });
          this.dialogVisible = false;
        }
      });
    }
  }
};
</script>
